var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search-normal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.719,
    height: 20.719,
    viewBox: "0 0 20.719 20.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.719,7.859A7.859,7.859,0,1,1,7.859,0,7.859,7.859,0,0,1,15.719,7.859Z",
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2,2,0,0",
    transform: "translate(16.719 16.719)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H20.719V20.719H0Z",
    fill: "#FFFFFF",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7b0769542388d7e63abccefd910a19e5.svg";
export { ForwardRef as ReactComponent };